import React, { Component } from 'react';
import { connect } from 'react-redux';
import translate from '../TranslateHOC';

class TechnicalError extends Component {
  render() {
    const { errorMessage } = this.props;

    return (
      <div>
        {errorMessage.error && (
          <div className="tech-error">
            <div className="tech-error__inner">
              <div className="tech-error__message">
                <h2 className="tech-error__title">
                  <span className="tech-error__icon" />
                  <span
                    dangerouslySetInnerHTML={{
                      __html: errorMessage.message.title,
                    }}
                  ></span>
                </h2>
                <div
                  className="tech-error__copy"
                  dangerouslySetInnerHTML={{
                    __html: errorMessage.message.copy,
                  }}
                ></div>
              </div>
              <div className="tech-error__ctas">
                {errorMessage.message.buttons.map((button, index) => (
                  <a
                    key={index}
                    href={button.url}
                    className="tech-error__btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {button.text}
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    curLang: state.curLang,
  };
}

export default translate(connect(mapStateToProps)(TechnicalError));
